export const fetchAllInventoriesQueryKey = () => ['inventories'];
export const getInventoryQueryKey = (
  inventoryId: number | string | undefined,
) => ['inventory', inventoryId || 0];
